(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    if (customElements.get('news-feed')) return;

    const RESTORE_KEY = 'vdh-news-state';
    const MAX_RESTORE_PAGES = 12;

    class NewsFeed extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.list = this.querySelector('[data-news-list]');
        this.pager = this.querySelector('[data-news-pager]');
        this.status = this.querySelector('[data-news-status]');
        this.retryButton = this.querySelector('[data-news-retry]');
        if (!this.list || !this.pager) return;

        this.sectionId = this.dataset.sectionId;
        this.firstPage = parseInt(this.dataset.currentPage, 10) || 1;
        this.lastPage = this.firstPage;
        this.loading = false;
        this.seen = new Set(
          Array.from(this.list.querySelectorAll('[data-news-item]'), (el) => el.dataset.newsItem)
        );

        const nextLink = this.pager.querySelector('a[rel="next"]');
        this.nextUrl = nextLink ? this.cleanUrl(nextLink.getAttribute('href')) : null;

        this.pager.setAttribute('data-enhanced', '');
        this.retryButton?.addEventListener('click', () => this.loadNext());

        this.rememberPosition = this.rememberPosition.bind(this);
        this.list.addEventListener('click', this.rememberPosition);
        window.addEventListener('pagehide', this.rememberPosition);

        if (!this.nextUrl) {
          this.finish();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
          },
          { rootMargin: '0px 0px 1400px 0px' }
        );

        this.restoreThenObserve();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('pagehide', this.rememberPosition);
      }

      async loadNext() {
        if (this.loading || !this.nextUrl) return false;
        this.loading = true;
        if (this.retryButton) this.retryButton.hidden = true;
        this.pager.setAttribute('aria-busy', 'true');
        this.status.textContent = 'Loading';

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.sectionId);

          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error('HTTP ' + response.status);

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fragment = document.createDocumentFragment();

          doc.querySelectorAll('[data-news-item]').forEach((item) => {
            const id = item.dataset.newsItem;
            if (!id || this.seen.has(id)) return; // never twice the same post
            this.seen.add(id);
            fragment.append(document.importNode(item, true));
          });

          this.list.append(fragment);
          this.lastPage = parseInt(url.searchParams.get('page'), 10) || this.lastPage + 1;

          const next = doc.querySelector('[data-news-pager] a[rel="next"]');
          this.nextUrl = next ? this.cleanUrl(next.getAttribute('href')) : null;
          this.status.textContent = '';

          if (!this.nextUrl) {
            this.finish();
          } else if (this.observer) {
            // Re-arm: if the sentinel is still within range, load again.
            this.observer.unobserve(this.pager);
            requestAnimationFrame(() => this.observer.observe(this.pager));
          }
          return true;
        } catch (error) {
          console.warn('[news-feed] could not load more posts', error);
          this.status.textContent = '';
          if (this.retryButton) this.retryButton.hidden = false;
          return false;
        } finally {
          this.loading = false;
          this.pager.removeAttribute('aria-busy');
        }
      }

      finish() {
        this.observer?.disconnect();
        this.pager.setAttribute('data-complete', '');
      }

      cleanUrl(href) {
        if (!href) return null;
        const url = new URL(href, window.location.origin);
        url.searchParams.delete('section_id');
        return url.pathname + url.search;
      }

      rememberPosition() {
        try {
          sessionStorage.setItem(
            RESTORE_KEY,
            JSON.stringify({
              path: window.location.pathname + window.location.search,
              firstPage: this.firstPage,
              lastPage: this.lastPage,
              scrollY: window.scrollY,
            })
          );
        } catch (e) {
          /* storage unavailable: feed still works, no restore */
        }
      }

      /* Back from an article: rebuild the loaded pages, return to the same spot. */
      async restoreThenObserve() {
        let state = null;
        try {
          const navigation = performance.getEntriesByType('navigation')[0];
          const raw = sessionStorage.getItem(RESTORE_KEY);
          if (navigation && navigation.type === 'back_forward' && raw) state = JSON.parse(raw);
          sessionStorage.removeItem(RESTORE_KEY);
        } catch (e) {
          state = null;
        }

        const canRestore =
          state &&
          state.path === window.location.pathname + window.location.search &&
          state.firstPage === this.firstPage &&
          state.lastPage > this.firstPage;

        if (canRestore) {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          const target = Math.min(state.lastPage, this.firstPage + MAX_RESTORE_PAGES);
          while (this.nextUrl && this.lastPage < target) {
            const ok = await this.loadNext();
            if (!ok) break;
          }
          requestAnimationFrame(() => window.scrollTo(0, state.scrollY || 0));
          if ('scrollRestoration' in history) {
            setTimeout(() => (history.scrollRestoration = 'auto'), 0);
          }
        }

        if (this.nextUrl && this.observer) this.observer.observe(this.pager);
      }
    }

    customElements.define('news-feed', NewsFeed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
